export const getBrowserWidth = function (): number {
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  return width;
};
